import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

export default ({ data, index, headers }) => {
  const isDraggable = !!data.columns[0].isDragHandle;
  const indexAdd = isDraggable ? 1 : 0;

  const [firstColumn] = isDraggable ? data.columns.slice(0, 1) : [];
  const restOfColumns = isDraggable ? data.columns.slice(1) : data.columns;

  return data.draggable ?
    <Draggable
      draggableId={'dnd-row-' + data.id}
      index={index}
      key={'dnd-row-' + data.id}
    >
      {(provided, snapshot) => (
        <tr style={data.style} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
          {firstColumn && <td
            {...provided.dragHandleProps}
            className={firstColumn.class ? firstColumn.class : ''}
            key={0}
            style={{
              textAlign: headers[0].style && headers[0].style.textAlign,
              width: headers[0].style && headers[0].style.width,
              justifyContent: headers[0].style && headers[0].style.textAlign === 'right' ? 'flex-end' : null,
              ...firstColumn.style
            }}
            colSpan={firstColumn.colSpan}
            title={firstColumn.title}
          >
            {firstColumn.print ? firstColumn.print(firstColumn.content) : firstColumn.content}
          </td>}
          {restOfColumns.map((column, index) =>
            <td
              className={column.class ? column.class : ''}
              key={index + indexAdd}
              style={{
                textAlign: headers[index + indexAdd].style && headers[index + indexAdd].style.textAlign,
                width: headers[index + indexAdd].style && headers[index + indexAdd].style.width,
                justifyContent: headers[index + indexAdd].style && headers[index + indexAdd].style.textAlign === 'right' ? 'flex-end' : null,
                ...column.style
              }}
              colSpan={column.colSpan}
              title={column.title}
            >
              {column.print ? column.print(column.content) : column.content}
            </td>
          )}
        </tr>
      )}
    </Draggable> : (
      <tr style={data.style}>
        {data.columns.map((column, index) =>
          <td
            className={column.class ? column.class : ''}
            key={index}
            style={{
              textAlign: headers[index].style && headers[index].style.textAlign,
              width: headers[index].style && headers[index].style.width,
              justifyContent: headers[index].style && headers[index].style.textAlign === 'right' ? 'flex-end' : null,
              ...column.style
            }}
            colSpan={column.colSpan}
            title={column.title}
          >
            {column.print ? column.print(column.content) : column.content}
          </td>
        )}
      </tr>
    );
};
